import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ResponsiveModule } from '@psu/utils/responsive';
import { OkayDialogComponent } from './okay-dialog.component';
import { OkayDialogService } from './okay-dialog.service';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, FlexLayoutModule, ResponsiveModule],
  declarations: [OkayDialogComponent],
  exports: [OkayDialogComponent],
  providers: [OkayDialogService],
})
export class OkayDialogModule {}
